<div class="content-rail">
  <h1 class="cg-h1">Error</h1>
  <cigna-leaf-inline-alert status="error">
    The requested URL was rejected. Please consult with your administrator. Your
    support ID is {{ (queryParams$ | async)?.supportId }}. Please contact
    {{ 'shared.common.shapePhone' | translate }}.
  </cigna-leaf-inline-alert>
</div>
